<template>
  <div
    id="auth-panel"
    class="side-panel test"
    :class="{ visible: visible, priority: priority }"
    @click="hide"
  >
    <div class="inner" @click.stop>
      <button
        id="hide-auth-trigger"
        type="button"
        class="circled small interactive grey hide-panel-trigger"
        @click="hide"
      >
        <svg-icon id="cross"></svg-icon>
      </button>

      <div class="tabbed sm">
        <internal-nav
          class="tabs uc no-ul tighter"
          :active-item="
            mode ? (mode === 'forgot_password' ? 'login' : mode) : 'login'
          "
          :items="navItems"
          @select="changeAuthMode"
        ></internal-nav>

        <div class="content-panes">
          <auth-login :class="{ active: mode === 'login' }"></auth-login>
          <auth-signup
            :class="{ active: mode === 'signup' }"
            ref="focus"
          ></auth-signup>
          <auth-forgot-password
            :class="{ active: mode === 'forgot_password' }"
          ></auth-forgot-password>
        </div>
      </div>
    </div>
  </div>
  <!-- /#auth-panel -->
</template>

<script>
import AuthLogin from "./Login";
import AuthSignup from "./Signup";
import AuthForgotPassword from "./ForgotPassword";

export default {
  components: {
    AuthLogin,
    AuthSignup,
    AuthForgotPassword,
  },

  data() {
    return {};
  },

  computed: {
    mode() {
      return this.$store.getters["user/authenticationMode"];
    },

    navItems() {
      return [
        { id: "login", label: "Log In" },
        { id: "signup", label: "Join" },
      ];
    },

    priority() {
      return this.$store.getters["user/authPriority"];
    },

    visible() {
      return this.mode !== null;
    },
  },

  methods: {
    changeAuthMode(which) {
      this.$store.commit("user/changeAuthMode", which.id);
    },

    hide() {
      if (
        window.location.href.includes("#login") ||
        window.location.href.includes("#sign-up")
      ) {
        window.history.pushState(
          "state obj or string",
          "url",
          window.location.href.substring(0, window.location.href.indexOf("#"))
        );
      }
      this.$store.commit("user/dismissAuth");
    },
  },
};
</script>
